import { getBadgeContent } from './getBadgeContent';

// This is a native JS implementation of jQuery's $.getScript, because jquery might not be available for
// server-side rendered React components
const loadScript = source => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    const prior = document.getElementsByTagName('script')[0];
    script.async = true;
    script.defer = true;
    function onloadHander(_, isAbort) {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = null;
        script.onreadystatechange = null;
        script = undefined;

        if (isAbort) {
          reject();
        } else {
          resolve();
        }
      }
    }
    script.onload = onloadHander;
    script.onreadystatechange = onloadHander;
    script.src = source;
    prior.parentNode.insertBefore(script, prior);
  });
};

const indexRoute = (categorySlug = '') => {
  if (categorySlug) {
    const dashedSlug = categorySlug.replace(/[_]/g, '-'); // dashed URLs for SEO
    return `/product/integrations/categories/${dashedSlug}`;
  }

  return '/product/integrations';
};

const showRoute = appSlug => {
  const dashedSlug = appSlug.replace(/[_]/g, '-'); // dashed URLs for SEO
  return `/product/integrations/${dashedSlug}`;
};

export { loadScript, indexRoute, showRoute, getBadgeContent };
